// extracted by mini-css-extract-plugin
export default {"page":"OnboardingWrapperPage_page__c5iNx","outletContainer":"OnboardingWrapperPage_outletContainer__o+pBM"};